"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLevels = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconLevels = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsx)("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "34",
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M38.75 15.7857H15C14.9365 15.7857 14.8755 15.7857 14.812 15.8474C14.2505 13.7224 12.312 12.1428 10 12.1428C7.68801 12.1428 5.68851 13.7224 5.18801 15.8474C5.12454 15.7857 5.0635 15.7857 5.00003 15.7857H1.25003C0.561525 15.7857 2.5034e-05 16.3312 2.5034e-05 17C2.5034e-05 17.6688 0.56155 18.2143 1.25003 18.2143H5.00003C5.0635 18.2143 5.12454 18.2143 5.18801 18.1526C5.74954 20.2776 7.68801 21.8572 10 21.8572C12.312 21.8572 14.3115 20.2776 14.812 18.1526C14.8755 18.1526 14.9365 18.2143 15 18.2143H38.75C39.4385 18.2143 40 17.6688 40 17C40 16.3312 39.4385 15.7857 38.75 15.7857ZM10 19.4286C8.6255 19.4286 7.5 18.3352 7.5 17C7.5 15.6648 8.6255 14.5714 10 14.5714C11.3745 14.5714 12.5 15.6648 12.5 17C12.5 18.3352 11.3745 19.4286 10 19.4286ZM38.75 27.9286H35C34.9365 27.9286 34.8755 27.9286 34.812 27.9902C34.2505 25.8652 32.312 24.2857 30 24.2857C27.688 24.2857 25.6885 25.8652 25.188 27.9902C25.1245 27.9286 25.0635 27.9286 25 27.9286H1.25003C0.561525 27.9286 2.5034e-05 28.474 2.5034e-05 29.1428C2.5034e-05 29.8116 0.56155 30.3571 1.25003 30.3571H25C25.0635 30.3571 25.1245 30.3571 25.188 30.2955C25.7495 32.4205 27.688 34 30 34C32.312 34 34.3115 32.4205 34.812 30.2955C34.8755 30.2955 34.9365 30.3571 35 30.3571H38.75C39.4385 30.3571 40 29.8116 40 29.1428C40 28.474 39.4385 27.9286 38.75 27.9286ZM30 31.5714C28.6255 31.5714 27.5 30.4781 27.5 29.1428C27.5 27.8076 28.6255 26.7143 30 26.7143C31.3745 26.7143 32.5 27.8076 32.5 29.1428C32.5 30.4781 31.3745 31.5714 30 31.5714ZM1.25 6.07144H15C15.0635 6.07144 15.1245 6.07144 15.188 6.00978C15.7495 8.13478 17.688 9.71432 20 9.71432C22.312 9.71432 24.3115 8.13478 24.812 6.00978C24.8755 6.00978 24.9365 6.07144 25 6.07144H38.75C39.4385 6.07144 40 5.52596 40 4.85716C40 4.18836 39.4385 3.64288 38.75 3.64288H25C24.9365 3.64288 24.8755 3.64288 24.812 3.70454C24.2505 1.57954 22.312 0 20 0C17.688 0 15.6885 1.57954 15.188 3.70454C15.1245 3.64288 15.0635 3.64288 15 3.64288H1.25C0.5615 3.64288 0 4.18836 0 4.85716C0 5.52596 0.561525 6.07144 1.25 6.07144V6.07144ZM20 2.42859C21.3745 2.42859 22.5 3.52193 22.5 4.85716C22.5 6.19239 21.3745 7.28573 20 7.28573C18.6255 7.28573 17.5 6.19239 17.5 4.85716C17.5 3.52193 18.6255 2.42859 20 2.42859Z",
      fill: color
    }, void 0)
  }), void 0);
});